export default "__VITE_ASSET__3889a8e6__"